import React from 'react';

import { fixNewsUrl } from '../../util/urlHelpers';

import IconNews from '../IconNews/IconNews';

const NewsImage = (props) => {
  const {
    imageClassName,
    iconClassName,
    imgUrl,
    link,
  } = props;

  const newsLink = fixNewsUrl(link);
  let image = <IconNews className={iconClassName} />;

  if (imgUrl) {
    image = <img src={imgUrl} className={imageClassName} />;
  }

  if (!newsLink) {
    return image;
  }

  return (
    <a
      target='_blank'
      href={newsLink}
    >
      {image}
    </a>
  );
};

export default NewsImage;
